import React, { useEffect, useState } from 'react';
import { Avatar, Flexbox, Label } from '../../../../common/fusion-ui';
import { checkNullStr, getJsonValue, isBoolTrue, isJsonValueTrue } from "../../../../common/fusion-ui/utils/ReactUtils";
import { CssVariant, DefStrNA, Messages } from '../../../../common/fusion-ui/config/FusionConfig';
import { useTheme } from '../../../../common/ProjectThemeProvider';
import { printError, printLog, sendRequest } from "../../../utils/AppUtils";
import { useToast } from "../../../../common/fusion-ui/provider/ToastProvider";
import { GenRouteUrls, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls } from "../../../config/AppConfig";
import { InvalidPanel, ThemedButton, ThemedIconButton } from "../../../index";

export const PeerProfile_Internal_Panel = React.memo(({
    recordId,
    borderless = true,
    fromPage = false,
    justifyAt = 'start',
}) => {
    const TAG = "PeerProfile_Internal_Panel";

    const mf = ModuleFieldsData[Modules.UserProfile];
    const theme = useTheme();
    const { showToast, changeToastVariant } = useToast();

    const Fields = {
        panelData: 'panelData',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        prevRecordId: 'prevRecordId',
        nextRecordId: 'nextRecordId',
    };
    const [fieldsData, setFieldsData] = useState({});
    useEffect(() => {
        // log('useEffect.recordId:', recordId);
        if (checkNullStr(recordId)) fetchPageData(recordId);
    }, [recordId]);

    return (<>
        <div className={'position-relative bg-infox w-100'}>
            <InvalidPanel
                color={theme.text70}
                success={getField(Fields.isDataFound)}
                loading={getField(Fields.isDataLoading)}
                msg={getField(Fields.dataLoadingMsg)}
                show404Image={true}
            />
            {/*header*/}
            <div className={"position-absolute"}
                // Updated by Vandit Tewari (6/11/24) - change the value of top from -1.7 to -2.7 bcz in phones it is overlaping with the avatar of the sender
                style={{ top: isBoolTrue(fromPage) ? '-2.7rem' : '0rem', right: '-.1rem' }}>
                <Flexbox
                    justifyAt={'end'}
                    direction={'row'}
                    overflow={'visible'}>
                    {/* Back to list button*/}
                    {isBoolTrue(fromPage) && <ThemedButton
                        className={'px-2 py-1 text-nowrap fs-sm fw-semi-bold'}
                        m={1}
                        height={'28px'}
                        outlined={true}
                        variant={theme.primaryBlue}
                        text={`Back to Profiles`}
                        href={ModuleRouteUrls[Modules.PeerProfiles]} />}

                    {/* prev-button */}
                    <ThemedIconButton
                        className={'p-1 text-nowrap fs-sm fw-semi-bold'}
                        m={1}
                        ml={2}
                        height={'28px'}
                        outlined={true}
                        variant={theme.primaryBlue}
                        disableVariant={'xl'}
                        icon={"bi bi-arrow-left"}
                        tooltip={"Previous"}
                        circular={false}
                        disabled={!checkNullStr(getField(Fields.prevRecordId))}
                        href={isBoolTrue(fromPage) ? `${GenRouteUrls.pp_internalPage}${getField(Fields.prevRecordId)}` : ''}
                        onClick={() => fetchPageData(getField(Fields.prevRecordId), false)} />

                    {/* next-button */}
                    <ThemedIconButton
                        className={'p-1 text-nowrap fs-sm fw-semi-bold'}
                        m={1}
                        ml={2}
                        height={'28px'}
                        outlined={true}
                        variant={theme.primaryBlue}
                        disableVariant={'xl'}
                        icon={"bi bi-arrow-right"}
                        tooltip={"Next"}
                        circular={false}
                        disabled={!checkNullStr(getField(Fields.nextRecordId))}
                        href={isBoolTrue(fromPage) ? `${GenRouteUrls.pp_internalPage}${getField(Fields.nextRecordId)}` : ''}
                        onClick={() => fetchPageData(getField(Fields.nextRecordId), false)} />
                </Flexbox>
            </div>

            {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)) &&
                <div>
                    {/* Profile Details */}
                    {/*Updated by Vandit Tewari (6/11/24) - add the style elemet as this details are overlaping with the control button at the top so shifted them down*/}
                    <div style={{ marginTop: '5vh' }}>
                        <div className={'w-100'}>
                            <div className={''}>
                                <Avatar
                                    wrapperClassName={''}
                                    imgClassName={'rounded-4'}
                                    circular={false}
                                    size={'90px'}
                                    justifyAt={justifyAt}
                                    // height={'106px'}
                                    bordered={false}
                                    showFullPreviewDialog={true}
                                    showInitials={true}
                                    nameForInitials={getPanelField(mf.fullName)}>
                                    {getPanelField(mf.memberImage)}
                                </Avatar>
                            </div>

                            <Label className="fw-bold fs-normal" widthClass={'100'}
                                color={theme.text}
                                textAt={justifyAt}>
                                {getPanelField(mf.fullName, DefStrNA)}
                            </Label>
                        </div>
                        <div className="ms-3x mt-1" style={{}}>
                            <table className={'w-100x'} style={{ color: theme.text }}>
                                <tbody>
                                    {/* Updated by Vandit Tewari on (8/11/24) - in every tr given a class 'wmInternalPageTrBreak' done this bcz below 560px the text in some td getting out of screen as these both comes in same row - declared in fusion css also in all td added class text-break*/}
                                    {/* highestEducation */}
                                    <tr className='wmInternalPageTrBreak'>
                                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start fw-semi-bold'}>{mf.highestEducation.title}:</th>
                                        <td className={'px-2 text-wrap text-block text-break'}>{getPanelField(mf.highestEducation, DefStrNA)}</td>
                                    </tr>

                                    {/* memberSpeciality */}
                                    <tr className='wmInternalPageTrBreak'>
                                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start fw-semi-bold'}>{mf.memberSpeciality1.titleAlt}:</th>
                                        <td className={'px-2 text-wrap text-break'}>{getPanelField(mf.memberSpeciality1, getField(mf.memberSpeciality2, DefStrNA))}</td>
                                    </tr>

                                    {/* memberBiography */}
                                    <tr className='wmInternalPageTrBreak'>
                                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start fw-semi-bold'}>{mf.memberBiography.titleAlt}:</th>
                                        <td className={'px-2 text-wrap text-block text-break'}>{getPanelField(mf.memberBiography, DefStrNA)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>}
        </div>
    </>)

    async function fetchPageData(recordId, checkBefore = true) {
        const fun = 'fetchPageData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            // if (!isFieldTrue(Fields.isDataFetched)) {
            log(fun, 'recordId:', recordId);
            updateField(Fields.isDataFetched, true);
            updateField(Fields.recordId, recordId);
            if (checkNullStr(recordId)) {
                updateField(Fields.panelData, {});
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.dataLoadingMsg, "");
                updateField(Fields.nextRecordId, null);
                updateField(Fields.prevRecordId, null);

                //send-request
                const REQUEST_OPTIONS = {
                    recordId: recordId,
                    getAdjacentRecordIds: true,
                };
                try {
                    sendRequest({
                        reqUrl: ReqUrls.pp__internalPage_fetchData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const panelData = getJsonValue(fetchedData, 'data', {});
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');

                            if (success) {
                                // toast(message, CssVariant.success)
                                updateField(Fields.panelData, panelData);
                                updateField(Fields.nextRecordId, getJsonValue(panelData, 'nextRecordId'));
                                updateField(Fields.prevRecordId, getJsonValue(panelData, 'prevRecordId'));
                                updateField(Fields.isDataFound, success);
                                updateField(Fields.isDataLoading, false);
                            } else {
                                toast(message, CssVariant.danger)
                                updateField(Fields.dataLoadingMsg, message);
                                updateField(Fields.isDataLoading, false);
                                updateField(Fields.isDataFound, false);
                            }
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast(Messages.fetchError, CssVariant.danger)
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } catch (error) {
                    toast(Messages.fetchError, CssVariant.danger)
                    logErr(fun, error);
                    updateField(Fields.dataLoadingMsg, Messages.fetchError);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            } else {
                toast('Record-id not found!', CssVariant.danger);
                updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }

    //======================Util Functions start=====================

    function getPanelField(colField, defValue) {
        return getJsonValue(getField(Fields.panelData), colField.column, defValue);
        // return getJsonValue(getField(Fields.panelData), colField, defValue);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({ ...prevState, [field]: value }));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default PeerProfile_Internal_Panel;
